import { render, staticRenderFns } from "./BigApplyBtn.vue?vue&type=template&id=0b035c9b&scoped=true&"
import script from "./BigApplyBtn.vue?vue&type=script&lang=js&"
export * from "./BigApplyBtn.vue?vue&type=script&lang=js&"
import style0 from "./BigApplyBtn.vue?vue&type=style&index=0&id=0b035c9b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b035c9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
